export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 20px 10px 28px',
    justifyContent: 'center',
    height: '265px',
    width: '720px'
  },
  row: {
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    marginRight: '20px'
  },
  error: {
    color: '#FF0000',
    fontSize: '10px'
  }
};
